import * as React from 'react';

import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import { WorkAccessControl } from '@components/work/WorkAccessControl';

export default connect(
    (state: ApplicationState) => ({
        ...state.identity,
        ...state.user,
        work: state.user.work,
    }),
    {}
)(WorkAccessControl as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
